import type { JSX } from 'solid-js';

export const containerStyle: JSX.CSSProperties = {
  position: 'absolute',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
};
